<template>
    <div class="dateIcon__container">
        <h4 class="dateIcon__dayString" v-text="day"></h4>
        <p class="dateIcon__dayNumber no-margin" v-text="dayOfMonth"></p>
        <h4 class="dateIcon__month" v-text="month"></h4>
    </div>
</template>

<script>
export default {
    name: 'DeliveryDateBox',
    props: {
        date: {
            required: true,
            type: Date,
        },
    },
    computed: {
        momentDate() {
            return this.$moment(this.date);
        },
        day() {
            return this.momentDate.format('ddd');
        },
        dayOfMonth() {
            return this.momentDate.format('D');
        },
        month() {
            return this.momentDate.format('MMM');
        },
    },
};
</script>
